<template>
    <div class="accountSetting accountLimits pl-xl-4">
        <!-- <h3 class="border-bottom pb-3 medium mb-4">Account Limits</h3> -->
        <div class="accountTier">
            <!-- <ul class="tierStep">
                <li>
                    <span class="completed position-absolute">
                        <feather type="check" size="24px"></feather>
                    </span>
                    <p class="mb-0">
                        {{ get_user.tier >= 1 ? "Verified" : "Not Verified" }}
                    </p>
                    <h5 class="semibold my-1">Tier 1</h5>
                    <p class="mb-0 d-flex align-items-center">
                        <feather :type="get_user.tier >= 1 ? 'check' : 'x'" size="14px" class="mr-1 green"></feather>
                        Register
                    </p>
                </li>
                <li>
                    <span class="completed position-absolute" :class="get_user.tier <= 2 ? 'd-none' : ''">
                        <feather type="check" size="24px"></feather>
                    </span>
                    <p class="mb-0">
                        {{ get_user.tier >= 3 ? "Verified" : "Not Verified" }}
                    </p>
                    <h5 class="semibold my-1">Tier 2</h5>
                    <p class="mb-0 d-flex align-items-center">
                        <feather :type="get_user.tier >= 3 ? 'check' : 'x'" size="14px" class="mr-1"
                            :class="get_user.tier >= 3 ? 'green' : 'red'"></feather>Verify your account
                    </p>
                </li>
                <li>
                    <span class="completed position-absolute" :class="get_user.tier <= 4 ? 'd-none' : ''">
                        <feather type="check" size="24px"></feather>
                    </span>
                    <p class="mb-0">
                        {{ get_user.tier >= 5 ? "Verified" : "Not Verified" }}
                    </p>
                    <h5 class="semibold my-1">Tier 3</h5>
                    <p class="mb-0 d-flex align-items-center">
                        <feather :type="get_user.tier >= 5 ? 'check' : 'x'" size="14px" class="mr-1"
                            :class="get_user.tier >= 5 ? 'green' : 'red'"></feather>Add and verify bank details
                    </p>
                </li>
            </ul> -->
            <div class="table-responsive border radius10">
                <table class="table upgradeAccount text-center mb-0">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>
                                <span class="completed circleCheck">
                                    <feather type="check" size="24px"></feather>
                                </span>
                                <h3 class="semibold">Tier 1 <span class="d-block">(Beginner)</span></h3>
                            </th>
                            <th>
                                <span class="circleCheck" :class="[{'completed' : parseInt(profileInfo.tier) >= 3}, {'disabled' : parseInt(profileInfo.tier) < 3}]">
                                    <feather type="check" size="24px"></feather>
                                </span>
                                <h3 class="semibold">Tier 2 <span class="d-block">(Pro)</span></h3>
                            </th>
                            <th>
                                <span class="circleCheck" :class="[{'completed' : parseInt(profileInfo.tier) == 5}, {'disabled' : parseInt(profileInfo.tier) < 5}]">
                                    <feather type="check" size="24px"></feather>
                                </span>
                                <h3 class="semibold">Tier 3 <span class="d-block">(Advance)</span></h3>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <h5 class="semibold text-left">Crypto Deposits</h5>
                            </td>
                            <td>$10k/ account <span class="d-block">(Lifetime)</span></td>
                            <td>$500k/ account<span class="d-block">(Lifetime)</span></td>
                            <td>Unlimited </td>
                        </tr>
                        <tr>
                            <td>
                                <h5 class="semibold text-left">Crypto Withdrawals</h5>
                            </td>
                            <td>$1k/ account<span class="d-block">(Lifetime)</span></td>
                            <td>$10k/ day <span class="d-block">(Lifetime)</span></td>
                            <td>$500k/ day <span class="d-block">(higher amount will be </span><span class="d-block">approved manually)</span></td>
                        </tr>
                        <tr>
                            <td>
                                <h5 class="semibold text-left">Fiat Deposits</h5>
                            </td>
                            <td class="red">-</td>
                            <td>$10k/ day<span class="d-block">$100k/ month</span></td>
                            <td>$500k/ day <span class="d-block">(higher amount will be </span><span class="d-block">approved manually)</span></td>
                        </tr>
                        <tr>
                            <td>
                                <h5 class="semibold text-left">Fiat Withdrawals</h5>
                            </td>
                            <td class="red">-</td>
                            <td>$10k/ day<span class="d-block">$100k/ month</span></td>
                            <td>$500k/ day <span class="d-block">(higher amount will be </span><span class="d-block">approved manually)</span></td>
                        </tr>
                        <tr>
                            <td>
                                <h5 class="semibold text-left">Exchange/ Trade</h5>
                            </td>
                            <td class="red">-</td>
                            <td>Yes</td>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>
                                <a href="javascript:void(0)" class="cap_btn successBtn">Verified</a>
                            </td>
                            <td>
                                <router-link v-if="parseInt(profileInfo.tier) == 1 || parseInt(profileInfo.tier) == 2" :to="parseInt(profileInfo.tier) == 1 ? '/individual-step3' : {path:'/view',query:{id:profileInfo.documents[0].ticket_id}}" class="cap_btn secondaryBG">Upgrade Account</router-link>
                                <a v-else href="javascript:void(0)" class="cap_btn successBtn">Verified</a>
                            </td>
                            <td>
                                <router-link v-if="parseInt(profileInfo.tier) >= 3 && parseInt(profileInfo.tier) != 5" :to="parseInt(profileInfo.tier) == 3 ? { name: 'questionnaire' } : '/help-centre'" class="cap_btn secondaryBG">Upgrade Account</router-link>
                                <a v-else-if="parseInt(profileInfo.tier) == 5" href="javascript:void(0)" class="cap_btn successBtn">Verified</a>
                                <a v-else href="javascript:void(0)" class="cap_btn disabled">Upgrade Account</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!--<a href="javascript:void(0)" class="cap_btn-b small px-3 py-2 upgrade">Upgrade Account Limit Now</a>
             <div class="limits">
                <h3 class="medium mb-4 pb-3">Account Limits</h3>
                <ul>
                    <li class="d-flex align-items-center justify-content-between mb-3">
                        <span class="d-flex align-items-center">
                            <span class="icon"><img src="../../../../../static/website/images/cost-th.svg" alt="Icon"
                                    title="Cost" /></span>
                            <h5 class="">
                                Deposit up to
                                <strong>{{ get_user.tier <= 1 ? "0.075" : "50" }} BTC</strong>
                            </h5>
                        </span>
                        <p class="mb-0">Enabled</p>
                    </li>
                    <li class="d-flex align-items-center justify-content-between mb-3">
                        <span class="d-flex align-items-center">
                            <span class="icon"><img src="../../../../../static/website/images/receive.svg" alt="Icon"
                                    title="Cost" /></span>
                            <h5 class="">Receive cryptocurrency</h5>
                        </span>
                        <p class="mb-0">
                            {{ get_user.tier >= 3 ? "Enabled" : "Disabled" }}
                        </p>
                    </li>
                    <li class="d-flex align-items-center justify-content-between mb-3">
                        <span class="d-flex align-items-center">
                            <span class="icon"><img src="../../../../../static/website/images/send.svg" alt="Icon"
                                    title="Cost" /></span>
                            <h5 class="">Send cryptocurrency</h5>
                        </span>
                        <p class="mb-0">
                            {{ get_user.tier >= 5 ? "Enabled" : "Disabled" }}
                        </p>
                    </li>
                </ul>
            </div> -->
        </div>
    </div>
</template>

<script>
import { registerStepsMixins } from "@/plugins/registerSteps";
import { commonAllmixins } from "@/plugins/commonAll";
import store from '@/store/store.js'
// import editAddress from './edit_Address'
// import editNumber from './edit_Number'
export default {
    name: "accountprofile",
    mixins: [registerStepsMixins, commonAllmixins],
    data() {
        return {
            notification_msg: "",
            notification_type: "",
            // tab: '1',
            submitted: false,
            // editAddress: false,
            // editNumber: false,

            fname: "",
            mName: "",
            lname: "",
            pageLoader: false,
            dob: "",
            address: "",
            city: "",
            state: "",
            country: "",
            area_code: "",
            acc_type: "",
            OrganizationType: {
                0: "Company",
                1: "Self Managed Super Fund",
                2: "Discretionary/Unit Trust",
                3: "Others",
            },
            
        };
    },
    components: {
        // editAddress,
        // editNumber
    },

    methods: {
        create_image(url, name) {
            var stx = this.stxx;
            var link = document.createElement("a");
            link.download = name;
            link.href = url;
            link.click();
        },
        ChangeTab(val) {
            this.tab = val;
            // this.editAddress = false
            // this.editNumber = false
            this.pageLoader = false;
        },
        Submit() {
            const _that = this;
            _that.submitted = true;
            _that.$validator.validate().then((valid) => {
                if (valid) {
                    let input_json = {
                        globalParams: {
                            f_name: _that.fname,
                            m_name: _that.mName,
                            l_name: _that.lname,
                            dob: _that.dob,
                            Address: _that.address,
                            City: _that.city,
                            State: _that.state,
                            Country: _that.country,
                            Areacode: _that.area_code,
                            Acc_type: _that.acc_type,
                        },
                        localParams: {
                            parameter: _that,
                        },
                    };
                }
            });
        },
    },
    created() {
        this.pageName("Account Profile");
        this._runGetProfileInfo({
            globalParams: {},
            localParams: {
                parameter: this,
            },
        });
    },
};
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/account_limits.vue